import { atom } from "recoil";

export const isExtendedValiditySubmitBlockedAtom = atom<boolean>({
  key: "isExtendedValiditySubmitBlockedAtom",
  default: false,
});
